var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1464 6.47576C27.974 2.63694 23.9666 -1.37198 20.1263 0.455593L2.57461 8.81367C-1.02334 10.5268 -0.800539 15.722 2.93139 17.1206L7.05473 18.6666C7.25585 18.7421 7.4385 18.8597 7.5904 19.0116C7.7423 19.1635 7.85993 19.3462 7.93539 19.5473L9.48146 23.6721C10.8815 27.4026 16.0752 27.6254 17.7883 24.0274L26.1464 6.47576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.39b320302be0013417bd477fa7a831c4.svg";
export { ForwardRef as ReactComponent };